module.exports = {"id":"dp2_4l1q4","text":"Collaborating through Digital Technologies","instructions":"Some collaboration tools include AI features such as suggestions or summaries.","multiselect":false,"questionType":"PickOne","random":false,"options":[{"id":"dp2_4l1q4-a1","text":"True","score":1.8},{"id":"dp2_4l1q4-a2","text":"Not sure","score":0},{"id":"dp2_4l1q4-a3","text":"False","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.4"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.4/l1q4.json
// module id = 1048
// module chunks = 41